export type InfoContactAction =
  | { type: 'SET_IS_FETCHING_CONTACT_CONTENT' }
  | { type: 'SET_FETCH_CONTACT_CONTENT_FAILED' }
  | { type: 'SET_CONTACT_CONTENT', content: Julius.Website.ContactPageViewModel };

  export const setIsFetching = (): InfoContactAction => ({
    type: 'SET_IS_FETCHING_CONTACT_CONTENT',
  });

  export const setFetchFailed = (): InfoContactAction => ({
    type: 'SET_FETCH_CONTACT_CONTENT_FAILED',
  });

  export const setContactContent = (content: Julius.Website.ContactPageViewModel): InfoContactAction => ({
    content,
    type: 'SET_CONTACT_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/components/InfoContact/Redux/actions.tsx